module.exports = __webpack_public_path__ + "img/play-btn-fill.922a64d7.svg";